;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"b374f225f40175197d1a5dc105b9206cd9dc4d96"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;import * as Sentry from '@sentry/nextjs';
import { EnvVariable, getEnv } from 'lib/helpers/envHelper';

const ENVIRONMENT = getEnv(EnvVariable.ENVIRONMENT);
const RELEASE = getEnv(EnvVariable.RELEASE);
const SENTRY_DSN = getEnv(EnvVariable.SENTRY_DSN);

const isDevelopment = ENVIRONMENT === 'developer';

const getRelease = () => (isDevelopment ? 'developer@latest' : RELEASE);

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: !isDevelopment,
  environment: ENVIRONMENT,
  release: getRelease(),
  integrations: [Sentry.replayIntegration()],
  ignoreErrors: [
    'Load failed',
    'TypeError: Failed to fetch',
    'Object Not Found Matching Id',
    'ResizeObserver loop completed with undelivered notifications.',
    'fetch failed',
  ],
  beforeSend(event, hint) {
    if ((hint?.originalException as any)?.name === 'ApiResponseError') {
      return null;
    }
    return event;
  },
});
